import { FlashCardQuizBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpFlashCardQuizBlock } from './AmpFlashCardQuizBlock';
import { FlashCardQuizBlock } from './FlashCardQuizBlock';

export const FlashCardsQuizBlockMapping: BlockMapping<FlashCardQuizBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: FlashCardQuizBlock,
    AmpComponent: AmpFlashCardQuizBlock,
  };
